import React from 'react';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './FedbackIcons.module.scss';
const FeedbackNegative = ({
  onClick
}) => /*#__PURE__*/React.createElement(Icon, {
  onClick: onClick,
  name: "thumbDown",
  classname: styles.root
});
export default FeedbackNegative;